import './InputBox.scss';

export const Input = ({
    label,
    icon: Icon,
    error,
    className = 'input__box',
    required,
    style,
    ...props
}) => {

    return (
        <div className={className + "__form-group"} style={{...style}}>
            <label className={className + "__form-label"}>
                {label} {required && <span className={className + "__required"}>*</span>}
            </label>

            <div className={className + "__input-wrapper " + (error ? 'has-error' : '')}>
                {Icon && (
                    <div className={className + "__input-icon"}>
                        <Icon size={18} />
                    </div>
                )}

                <input
                    className={className + "__form-input " + (Icon ? 'with-icon' : '') + " " + className}
                    required={required}
                    {...props}
                />
            </div>

            {error && <p className={className + "__error-text"}>{error}</p>}
        </div>
    );
};

export const TextArea = ({
    label,
    icon: Icon,
    error,
    className = 'input__box',
    required,
    ...props
}) => {
    return (
        <div className={className + "__form-group"}>
            <label className={className + "__form-label"}>
                {label} {required && <span className={className + "__required"}>*</span>}
            </label>

            <div className={className + "__input-wrapper textarea-wrapper " + (error ? 'has-error' : '')}>
                {Icon && (
                    <div className={className + "__input-icon textarea-icon"}>
                        <Icon size={18} />
                    </div>
                )}

                <textarea
                    className={className + "__form-textarea " + (Icon ? 'with-icon' : '') + " " + className}
                    required={required}
                    {...props}
                />
            </div>

            {error && <p className={className + "__error-text"}>{error}</p>}
        </div>
    );
};
